<template>
  <div :id="peer.id">
    <span v-if="peer.role === 'host' || peer.role === 'hybrid'" class="peer-name-single">
      {{ peer.displayName + " " }}
      <b-icon v-if="peer.micPaused && peer.role === 'host'" icon="microphone-off" class="mic-icon" />
      <b-icon
        v-if="connectionType === 'slow-2g'"
        icon="signal-cellular-outline"
        class="signal-icon has-text-danger"
        size="is-small"
      />
      <b-icon v-if="connectionType === '2g'" icon="signal-cellular-1" class="signal-icon is-orange" size="is-small" />
      <b-icon v-if="connectionType === '3g'" icon="signal-cellular-2" class="signal-icon is-yellow" size="is-small" />
      <b-icon v-if="connectionType === '4g'" icon="signal-cellular-3" class="signal-icon is-success" size="is-small" />
    </span>
  </div>
</template>
<script>
/**
 * Placeholder tile for participants without video showing name and mic status
 * @displayName Host no Video
 */
import { mapState } from "vuex";

export default {
  name: "HostVideo",
  components: {},
  props: {
    peer: Object,
    width: String,
    currentUserCount: Number,
  },
  computed: {
    ...mapState({
      role: (state) => state.mediasoup.role,
      peers: (state) => state.mediasoup.peers,
    }),
    peerNameSize() {
      if (this.currentUserCount > 9) {
        return "0.75rem";
      } else {
        return "1rem";
      }
    },
    connectionType() {
      // filtering out the peer whose connectionType is required
      let hostpeer = this.peers.filter(
        (peer) => (peer.role === "host" || peer.role === "hybrid") && peer.id === this.peer.id,
      );
      console.log("host peer", hostpeer[0]);
      return hostpeer[0].connectionType;
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.peer-name-single {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 1.25rem;
  line-height: 1;
  color: white;
  font-weight: 700;
}
.signal-icon {
  padding-left: 1rem;
}
</style>
